import {
  FETCH_ANALYTICS_CANDIDATES_OPPS,
  FETCH_ANALYTICS_OPPORTUNITIES,
  FETCH_ANALYTICS_CANDIDATES_PROFESSIONS,
  FETCH_ANALYTICS_AVERAGE_TIME
} from "../actions/analytics";

const initialState = {};

const analytics = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case FETCH_ANALYTICS_OPPORTUNITIES.RESOLVED:
      return {
        ...state,
        opportunities: payload
      };

    case FETCH_ANALYTICS_CANDIDATES_OPPS.RESOLVED:
      return {
        ...state,
        candidates: payload
      };

    case FETCH_ANALYTICS_CANDIDATES_PROFESSIONS.RESOLVED:
      return {
        ...state,
        professions: payload
      };

    case FETCH_ANALYTICS_AVERAGE_TIME.RESOLVED:
      return {
        ...state,
        averageTime: payload
      };

    default:
      return state;
  }
};

export default analytics;
